import { Table } from "../../../components/table-components/Table";
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { TableBody } from "../../../components/table-components/TableBody";
import { PageFooter } from "../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../assets/typography/typography";
import { IntegrationListItem } from "../models/integrations";
import { IntegrationsListTableRow } from "./IntegrationsListTableRow";
import { MutateIntegrationDrawer } from "./MutateIntegrationDrawer";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";
type Props = {
  integrations: IntegrationListItem[] | undefined;
};

export const IntegrationsTable = ({ integrations }: Props) => {
  const { option, removeOption } = useSearchParamsManipulation();

  return (
    <div>
      <Table>
        <thead>
          <TableRowHeader>
            <TableCellHeaderText>Integration</TableCellHeaderText>
            <TableCellHeaderText>Integration name</TableCellHeaderText>
            <th />
          </TableRowHeader>
        </thead>
        <TableBody>
          {integrations?.map((integration, i) => {
            return (
              <IntegrationsListTableRow key={i} integration={integration} />
            );
          })}
        </TableBody>
      </Table>
      <PageFooter>
        <StyledText className="bodyTextRegular mb-0">
          {integrations?.length}{" "}
          {integrations?.length === 1 ? "integration" : "integrations"} in total
        </StyledText>
      </PageFooter>
      <MutateIntegrationDrawer
        isOpen={!!option}
        onClose={() => removeOption()}
        integration={integrations?.find((i) => i.id === option)}
      />
    </div>
  );
};
